import CandidateFitnessItem from "./CandidateFitnessItem";

export default CandidateFitnessItem;
